<template>
    <div class="toggle-solution">
        <!-- Solution button -->
        <a
            v-bind="$attrs"
            :href="'#' + id"
            data-bs-toggle="collapse"
            role="button"
            aria-expanded="false"
            aria-controls="collapseExample"
        >
            {{ linkLabel }} <i class="fa-solid fa-chevron-down"/>
        </a>

        <!-- Solution content -->
        <div
            :id="id"
            class="collapse"
        >
            <slot/>
        </div>
    </div>
</template>

<script>
import { getCurrentInstance } from 'vue'

export default {
    name: 'ToggleSolution',
    props: {
        name: {
            type: String,
            default: 'ответ'
        },
        labelOverwrite: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            id: 'solution' + getCurrentInstance().uid,
            linkLabel: this.name,
        }
    },
    mounted() {
        if (this.labelOverwrite) {
            $(`[href="#${this.id}"]`).addClass('label-overwrite');
        }
        $('#' + this.id).on('show.bs.collapse hide.bs.collapse', () => {
            $(this.$el).toggleClass('opened')
        })
    },
}
</script>

<style lang="scss">
.toggle-solution {
    a:first-child {
        padding-bottom: 3px;
        border-bottom: 1px dashed transparent;
        line-height: 1.3rem;
        transition: none;
        &:not(.label-overwrite)::before {
            content: 'Показать ';
        }
        &:hover {
            border-bottom: 1px dashed #555;
            text-decoration: none !important;
        }
        i {
            margin-left: 1px;
            font-size: .9rem;
            transform-origin: 50% 53%;
            transition: .3s ease;
        }
    }
    &.opened {
        & > a i {
            transform: rotate(-180deg);
        }
        & > a:not(.label-overwrite)::before {
            content: 'Скрыть ';
        }
    }
    & a + div p:first-of-type {
        margin-top: 3px;
    }
}
</style>
